import styled from 'styled-components';

const BreadcrumbsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  .breadcrumbs-item {
    display: inline-block;
    position: relative;
    &:hover {
      color: ${({ theme }) => theme.colors.dark[100]};
      &::after {
        content: '';
        position: absolute;
        border-bottom: 1px solid ${({ theme }) => theme.colors.dark[100]};
        bottom: 0;
        width: 100%;
      }
    }
  }

  .separator {
    color: ${({ theme }) => theme.colors.dark[60]};
  }

  .active-item {
    color: ${({ theme }) => theme.colors.dark[100]};
    svg {
      path {
        fill: ${({ theme }) => theme.colors.dark[100]};
      }
    }
    a {
      color: ${({ theme }) => theme.colors.dark[100]};
    }
  }

  svg {
    path {
      fill: ${({ theme }) => theme.colors.dark[60]};
    }
  }

  a,
  span {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.dark[60]};
  }
`;

export default BreadcrumbsWrapper;
